const faqs = [
    { 
        id: 1, 
        heading: 'How do I book a taxi?',
        content: 'Booking a taxi is easy! You can book through our website, mobile app, or by calling our 24/7 customer service. Just provide your pickup and drop-off locations, choose your taxi type, and confirm the booking.',
    }, 
    { 
        id: 2,
        heading: 'What payment methods do you accept?',
        content: 'We accept various payment methods, including credit/debit cards, mobile wallets, and cash. You can choose your preferred payment option at the time of booking or pay directly to the driver.',
    },
    {
        id: 3, 
        heading: 'What is your cancellation policy?',
        content: 'You can cancel your taxi booking free of charge up to 30 minutes before the scheduled pickup time. If you cancel after this period, a cancellation fee may apply.',
    },
    {
        id: 4,
        heading: 'What safety measures are in place?',
        content: 'Our drivers are trained to follow strict safety protocols, including regular vehicle sanitization, mandatory mask-wearing, and contactless payment options, to ensure your safety during the ride.',
    },
    {
        id: 5,
        heading: 'What types of taxis are available?',
        content: 'We offer a variety of taxi options to suit your needs, including Economy, Standard, and Luxury vehicles. You can choose the type that best fits your budget and preferences.',
    },
];

export default faqs;